import { Field, useFormikContext } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { OfferType } from 'legacy/events/types';
import classnames from 'classnames';
import styles from 'legacy/common/components/form/Form.module.scss';

const OfferName = () => {
  const { t } = useTranslation('events');
  const { values, setFieldValue, errors } = useFormikContext<OfferType>();
  const hasActiveContract = values.contracts?.length > 0;
  return (
    <>
      <div className="flex flex-col mb-1 text-[12px] text-[#2A2A2A] leading-[15px]">
        {t('settings.promoterOffers.offerForm.offerName')}
      </div>
      <Field
        type="text"
        name="name"
        disabled={hasActiveContract}
        onChange={(e) => setFieldValue('name', e.target.value)}
        value={values.name}
        placeholder={t('settings.promoterOffers.offerForm.offerNamePlaceholder')}
        className={classnames(
          'w-full border-1 border-[#DCDCDC] px-4 py-2 mx-auto h-12 rounded-md placeholder:text-[#B1B1B1] placeholder:text-sm placeholder:font-normal text-[#151515] text-sm font-normal',
          {
            [styles.errorField]: errors.name
          }
        )}
      />
      {errors.name && (
        <div className={classnames(styles.error)}>{errors.name}</div>
      )}
    </>
  );
};

export default OfferName;
